module.exports = __webpack_public_path__ + "img/album-collection.ff4079df.svg";